import { createScopeFromContext } from 'bunja/react';
import { createContext } from 'react';

export const SymbolContext = createContext<string>(null as unknown as string);
export const SymbolScope = createScopeFromContext(SymbolContext);
